import { isMobile } from "react-device-detect";
import styled from "styled-components";
import "../assets/css/flex-table.css";

const limitprop = (props) => {
  if (props.selfexcludion) {
    return "flex-table-row justify-content-center py-5";
  }
  return "flex-table-row justify-content-center flex-wrap";
};

export const StyledLimitWrapper = styled.div.attrs((props) => ({
  className: limitprop(props),
}))`
  align-items: ${({ timelimitAbc }) =>
    timelimitAbc ? "baseline" : "flex-end"};

  ${({ selfexcludion }) =>
    !selfexcludion &&
    `
      padding: var(--limitWrapperPadding);
      @media (max-width: 767px) {
        padding: var(--limitWrapperPaddingMobile);
      }
    `}

  .form-control:disabled {
    background-color: #45454573 !important;
  }
  text-align: ${({ verification }) => verification && "left"};
  max-width: ${(reviewTransactions) => (reviewTransactions ? "1024px" : "")};
  margin: ${(reviewTransactions) => (reviewTransactions ? "auto" : "")};
  padding-bottom: ${(reviewTransactions) =>
    reviewTransactions ? "0 !important" : ""};
  button {
    margin: ${(reviewTransactions) =>
      reviewTransactions && isMobile ? "2rem 1rem" : ""};
  }
`;

export const StyledLimitSelect = styled.div.attrs((props) => ({
  className: "form-group col-md-3",
}))``;

export const RealityCheckWrapper = styled.div.attrs((props) => ({
  className: "flex-table-row justify-content-left",
}))`
  color: ${({ resetAt }) => (resetAt ? "#6c757d" : "")};
  font-size: ${({ resetAt }) => (resetAt ? "12px" : "")};
  p {
    color: var(--smallHeaderABC);
  }
  padding-top: ${({ extrapadding }) => (extrapadding ? "1rem" : "")};
  text-align: ${({ extrapadding }) => (extrapadding ? "center" : "")};
`;

export const IncreaseLimit = styled.div.attrs({
  className: "flex-table-row justify-content-center p-3 border-0",
})``;

export const StyledTimeLimit = styled.div.attrs({
  className: "form-group col-md-4",
})`
  @media (min-width: 768px) {
    padding-bottom: var(--limitTimeLimitPaddingBottomDesktop);
  }

  .invalid-feedback {
    text-align: left;
  }
  label {
    margin-bottom: 0;
    line-height: 0;
  }
  .ver-check {
    .custom-input {
      border-radius: 0.5rem 0 0 0.5rem !important;
    }
    .invalid-feedback {
      margin-top: 55px;
    }
  }
`;

export const StyledSectionTimeLimit = styled.div.attrs((props) => ({
  className: `flex-table-row ${props.padding} justify-content-center ${props.border}`,
}))``;

export const MessageLock = styled.div.attrs({
  className: `flex-table-row text-center p-3`,
})``;

export const StyledIndefiniteTimeout = styled.div.attrs({
  className:
    "flex-table-row justify-content-center p-3 border border-top-0 rounded-bottom",
})``;

export const ExcludedGamesWrapper = styled.div.attrs({
  className: "m-auto w-100",
})`
  padding-top: var(--excludedGamesPaddingTop);
  border-bottom: var(--excludedGamesBorderBottom);
`;

export const SectionExcludedGameWeapper = styled.div.attrs((props) => ({
  className: `flex-table-row justify-content-center ${props.excludedlimits}`,
}))`
  ${(props) => {
    if (props.spanStyle) {
      return `
      .btn {
        font-size: inherit;
      }

      @media (max-width: 767px) {
        .form-check-inline {
          font-size: 0.7rem;
        }
      }
      `;
    }
    if (props.realitycheck) {
      return `
      border-left: 1px solid var(--bordercolor) !important;
      border-right: 1px solid var(--bordercolor)!important;
      `;
    }
  }}
`;

export const StyledBlockedGames = styled.div.attrs({
  className:
    "flex-table-row flex-table-row-header justify-content-center border-top border-bottom",
})``;

export const BlockedGamesTableCell = styled.div.attrs({
  className: "flex-table-cell title-content col-md-4",
})``;

export const StyledCooldownExplanation = styled.div`
  width: 610px;
  ${(props) =>
    props.cooldownprop &&
    !props.depositlimit &&
    `
      @media (max-width: 767px) {
        position: relative;
        top: var(--cooldownExplanationTopMobile);
        left: 15px;
      }
    `}
`;
export const StyledCooldownExplanationSmall = styled.small.attrs({
  className: "form-text text-muted",
})``;

export const RemainingAmountWrapper = styled.div`
  color: red;
`;

export const ContactSaferGamingWrap = styled.div`
  text-align: center;
  width: 100%;
  padding: 3rem 0;

  & > button.btn-first {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    white-space: nowrap;
    margin-left: auto;
    margin-right: auto;
  }

  textarea.form-control::placeholder {
    color: var(
      --contactSaferGamingPlaceholderColor,
      var(--inputphcolor)
    ) !important;
    opacity: var(--contactSaferGamingPlaceholderOpacity, 0.4) !important;
    -webkit-text-fill-color: var(
      --contactSaferGamingPlaceholderColor,
      var(--inputphcolor)
    );
  }
`;
